var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 65,
    viewBox: "0 0 85 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3402 19.893L23.8582 15.711V0H33.3402V19.893Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5441 0H22.6541V5.931H34.5441V0Z",
    fill: "#E7E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3402 5.93103H23.8582L26.3082 8.38203H33.3402V5.93103Z",
    fill: "#8A8A8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8922 19.893L62.4092 15.711V0H71.8922V19.893Z",
    fill: "#B8B8B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0961 0H61.2061V5.931H73.0961V0Z",
    fill: "#E7E7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8922 5.93103H62.4092L64.8602 8.38203H71.8922V5.93103Z",
    fill: "#8A8A8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.435 4.32703L84.12 29.376V64.251H6.75098V4.32703L45.435 29.376V4.32703Z",
    fill: "#E7E7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 64.251H44.174L7 27.078V64.251Z",
    fill: "#CECECE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75098 0V4.32701L45.435 29.376V25.049L6.75098 0Z",
    fill: "#3A3A3A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75098 4.32703V7.60602L45.435 32.655V29.376L6.75098 4.32703Z",
    fill: "#ADADAD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.238 21.719H10.501V23.296H18.238V21.719Z",
    fill: "#3A3A3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2369 20.67H10.4999H9.45093V21.719V23.296V24.345H10.4999H18.2369H19.2859V23.296V21.719V20.67H18.2369ZM18.2369 23.296H10.4999V21.719H18.2369V23.296Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4351 0V4.32701L84.1201 29.376V25.049L45.4351 0Z",
    fill: "#3A3A3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4351 4.32703V7.60602L84.1201 32.655V29.376L45.4351 4.32703Z",
    fill: "#ADADAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9221 21.719H49.1851V23.296H56.9221V21.719Z",
    fill: "#3A3A3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.922 20.67H49.185H48.136V21.719V23.296V24.345H49.185H56.922H57.971V23.296V21.719V20.67H56.922ZM56.922 23.296H49.185V21.719H56.922V23.296Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.657 42.807H57.97V45.97H72.657V42.807Z",
    fill: "#3A3A3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.657 45.97H57.97V64.252H72.657V45.97Z",
    fill: "#5C5C5C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.12 64.251H72.657V42.807L84.065 54.216L84.12 64.251Z",
    fill: "#CECECE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7548 44.175H26.8088V55.1201H34.7548V44.175Z",
    fill: "#747474"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0658 44.175H36.1218V55.1201H44.0658V44.175Z",
    fill: "#747474"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1219 42.807H34.7539H25.4409V56.488H30.0969H31.4649H34.7549H36.1229H39.4109H40.7799H45.4369V42.807H36.1219ZM30.0969 55.119H26.8079V44.174H30.0969V55.119ZM34.7549 55.119H31.4649V44.174H34.7549V55.119ZM39.4099 55.119H36.1219V44.174H39.4099V55.119ZM44.0669 55.119H40.7789V44.174H44.0669V55.119Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1171 31.4709H9.55908V54.31H19.1171V31.4709Z",
    fill: "#3A3A3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.559 31.4709H0V54.31H9.559V31.4709Z",
    fill: "#747474"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.559 54.3099H0V64.2509H9.559V54.3099Z",
    fill: "#3A3A3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1171 54.3099H9.55908V64.2509H19.1171V54.3099Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.773 27.078H14.675H13.33H10.23H8.887H5.787H4.443H1.345H0V28.422V31.471H1.345V28.422H4.443V31.471H5.787V28.422H8.887V31.471H10.23V28.422H13.33V31.471H14.675V28.422H17.773V31.471H19.117V28.422V27.078H17.773Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.8231e6fd76fb620cbe521c2e8bc75408.svg";
export { ForwardRef as ReactComponent };